import React, {useEffect, useState} from 'react'
import PaymentForm from './PaymentForm'

const CreatePayment = props => {
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
    let sqpPaymentScript = document.createElement("script");
    sqpPaymentScript.src = "https://js.squareup.com/v2/paymentform";
    sqpPaymentScript.type = "text/javascript";
    sqpPaymentScript.async = false;
    sqpPaymentScript.onload = () => {
      setLoaded(true);
    };
    document.head.appendChild(sqpPaymentScript);
  }, []);

  return (
    <div className="App">
      <br /><br /><br /><br />
      {loaded && <PaymentForm 
        paymentForm={window.SqPaymentForm}
        GUID={props.GUID}
        Product = {props.Product}
        Id={props.Id}
      />}
      
    </div>
  );

}

export default CreatePayment

